export default __webpack_public_path__ + "dfb65b9e0ca713a7041011c74318bcdf.webp";